const setTransparentImage = (image: string | undefined) => {
  if (image?.includes('?') && !image?.includes('.jpg') && !image?.includes('.png'))
    return image?.replace('?', '.png?');
  return image;
};

export default setTransparentImage;
